import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import SectionContent from './SectionContent';
import SectionsList from './SectionsList';
import SectionCreate from './SectionCreate';

const Container = styled.div`
  @media (min-width: 1024px) {
    max-width: 100rem;
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
`;

const SideWrapper = styled.div`
  @media (min-width: 1024px) {
    grid-column: span 2 / span 2;
    padding-bottom: 4rem;
  }
`;

const Wrapper = styled.div`
  @media (min-width: 1024px) {
    grid-column: span 10 / span 10;
    padding-bottom: 4rem;
  }
`;

const SelectSection = ({
  sections,
  handleSectionSelect,
  selectedSection,
  currentSection,
  sectionNodes,
  setSelectedPosition,
  selectedPosition,
  creatingSection,
  setCreatingSection,
  setNewSectionName,
  setNewSectionSummary,
  newSectionName,
  newSectionSummary,
  reportSettings,
}) => {
  return (
    <Container>
      <SideWrapper>
        <SectionsList
          selectedSection={selectedSection}
          currentSection={currentSection}
          handleSectionSelect={handleSectionSelect}
          sections={sections}
          setCreatingSection={setCreatingSection}
          creatingSection={creatingSection}
        />
      </SideWrapper>
      <Wrapper>
        {!creatingSection && (
          <SectionContent
            sectionNodes={sectionNodes}
            setSelectedPosition={setSelectedPosition}
            selectedPosition={selectedPosition}
            reportSettings={reportSettings}
          />
        )}
        {creatingSection && (
          <SectionCreate
            setNewSectionName={setNewSectionName}
            setNewSectionSummary={setNewSectionSummary}
            newSectionName={newSectionName}
            newSectionSummary={newSectionSummary}
          />
        )}
      </Wrapper>
    </Container>
  );
};

SelectSection.propTypes = {
  sections: PropTypes.array,
  selectedSection: PropTypes.object,
  handleSectionSelect: PropTypes.func,
  currentSection: PropTypes.object,
  sectionNodes: PropTypes.array,
  setSelectedPosition: PropTypes.func,
  selectedPosition: PropTypes.number,
  creatingSection: PropTypes.bool,
  setCreatingSection: PropTypes.func,
  setNewSectionName: PropTypes.func,
  setNewSectionSummary: PropTypes.func,
  newSectionName: PropTypes.string,
  newSectionSummary: PropTypes.string,
  reportSettings: PropTypes.object,
};

export default SelectSection;
